module.exports = __webpack_public_path__ + "download/static/img/anniu.7df91d2f.png";